import React from 'react';
import { useLinkHandler } from 'hook/event.hook';
import { useViewModule } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { MARKETPLACE_BUSINESS_OFFERS } from 'types/morph.pagePosition.constants';
import { BUSINESS_LOAN_MARKETPLACE } from 'types/mrph.pageName.constants';
import BusinessLoansOffersView from './BusinessLoansOffersView';

const BusinessLoansOffersController = props => {
  const { eventHandler, modulePosition } = props;
  const onLinkClickCallback = useLinkHandler(eventHandler);

  useViewModule(
    getViewModuleTrackingAttributes(
      MARKETPLACE_BUSINESS_OFFERS,
      modulePosition,
      null,
      BUSINESS_LOAN_MARKETPLACE,
    ),
  );

  return (
    <BusinessLoansOffersView
      {...props}
      onLinkClickCallback={onLinkClickCallback}
    />
  );
};

export default BusinessLoansOffersController;
